module.exports = __webpack_public_path__ + "img/gqr-logo.87c85c8d.webp";